import scriptjs from 'scriptjs';

const BMAP_STATUS_SUCCESS = 0;

let BMap;

const loadPosition = (successCallback, errorCallback) => {
    const geolocation = new BMap.Geolocation();
    geolocation.getCurrentPosition(function(res) {
        if (geolocation.getStatus() === BMAP_STATUS_SUCCESS) {
            successCallback(res.point);
        } else if (errorCallback && typeof errorCallback === 'function') {
            errorCallback();
        }
    });
};
const getCurrentPosition = (successCallback, errorCallback) => {
    if (typeof BMap !== 'undefined') {
        loadPosition(successCallback, errorCallback);
    } else {
        scriptjs(
            [
                'https://api.map.baidu.com/getscript?v=2.0&ak=KQMz9KcIzBwWNUgbHWUHZGSD&services=',
                'https://sapi.map.baidu.com/api?v=2.0&ak=KQMz9KcIzBwWNUgbHWUHZGSD&s=1&callback='
            ],
            () => {
                BMap = window.BMap;
                loadPosition(successCallback, errorCallback);
            }
        );
    }
};

export default {
    getCurrentPosition
};
